import _get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import { getProductConfiguration } from './productConfigTransformer';
const getInventorySpec = function (data, exteriorColorSimple, pageType) {
  if (data === void 0) {
    data = {};
  }
  const spec = {};
  if (pageType !== 'dealer') {
    spec.odometer = _get(data, 'mileage.value', '0').replace(',', '').replace('miles', '') + ' mi';
  }
  spec.exteriorColor = exteriorColorSimple || _get(data, 'exterior.value', '').toUpperCase() || _get(data, 'color.exteriorColorSimple', '').toUpperCase() || _get(data, 'color.label', '') === 'Exterior Color' && _get(data, 'color.value', '').toUpperCase();
  return spec;
};
export const getInventoryData = function (inventory, pageType) {
  if (pageType === void 0) {
    pageType = '';
  }
  if (_get(inventory, 'id')) {
    const {
      bodyStyleCodes,
      exteriorColorSimple,
      id,
      listingType = '',
      mpgCity = '',
      mpgHighway = '',
      owner = {},
      pricingDetail = {},
      specifications,
      stockNumber,
      styleId,
      type,
      vin,
      year
    } = inventory;
    const {
      salePrice = '',
      msrp = ''
    } = pricingDetail;
    const vehicleType = type && type.toUpperCase() || listingType.toUpperCase();
    const make = _get(inventory, 'make.name') || (typeof inventory.make === 'string' ? inventory.make : '');
    const model = _get(inventory, 'model.name') || (typeof inventory.model === 'string' ? inventory.model : '');
    const tileType = _get(inventory, 'productTiles.[0].tileType', '');
    const isCarFax = tileType.includes('CARFAX') || false;
    const data = {
      vehicleId: pageType !== 'dealer' || isCarFax ? id : undefined,
      vin,
      bodyStyle: bodyStyleCodes,
      make: make?.toUpperCase(),
      model: model?.toUpperCase(),
      vehicleType,
      fuelEconomy: `${mpgCity} mpg city,${mpgHighway} mpg hwy`,
      stockNumber,
      year,
      price: vehicleType === 'NEW' ? msrp : salePrice,
      chromeStyleId: styleId,
      listingCode: owner?.id ?? null,
      ...getInventorySpec(specifications, exteriorColorSimple, pageType)
    };
    const dataCopy = cloneDeep(data);

    // remove all undefined
    return Object.entries(dataCopy).reduce((acc, _ref) => {
      let [key, value] = _ref;
      if (value) {
        acc[key] = value;
      }
      return acc;
    }, {});
  }
  return {};
};
export const buildListingChunks = (listings, _ref2) => {
  let {
    rank,
    listingType
  } = _ref2;
  // build listing objects so that pixall can convert
  // r-19.lt-lstg.i-525454350.lc-70185499.n-JM1GJ1V53G1484191.m-MAZDA
  const getChunkListingType = listing => {
    if (listingType === 'sim' && listing.vehicleHighlight?.isVehicleHighlight) {
      return 'highlight';
    }
    return listingType;
  };
  const pixallListings = listings.map((listing, index) => ({
    rank: rank + index,
    // r-1
    ...getInventoryData(listing),
    listingCode: _get(listing, 'owner.id', null),
    listingType: getChunkListingType(listing) // lt-lstg
  }));

  // each impression should take up to 25 listings
  const chunkLength = Math.ceil(pixallListings.length / 25);
  const chunks = Array(chunkLength).fill([]).map((arr, index) => pixallListings.slice(index * 25, index * 25 + 25));
  return chunks;
};
export const getCDLVehicleTransformer = function (vehicle, additionalMapping) {
  if (additionalMapping === void 0) {
    additionalMapping = {};
  }
  const vehicleCopy = cloneDeep(vehicle);
  const keyPropertiesMapping = {
    bodyStyleGroup: 'bodyStyle',
    descriptionExists: 'description',
    driveTrain: 'driveTrain',
    fuelType: 'fuelType',
    legacyConfigurationId: 'vehicleId',
    productConfiguration: 'productConfiguration',
    sellerType: 'sellerType',
    seriesId: 'seriesId',
    subCategory: 'subCategory',
    transmission: 'transmission',
    trimId: 'trimId',
    ...additionalMapping
  };
  const transformedVehicle = {};
  Object.entries(keyPropertiesMapping).forEach(_ref3 => {
    let [key, value] = _ref3;
    transformedVehicle[key] = vehicleCopy[value];
  });
  if (!transformedVehicle.trimId) {
    transformedVehicle.trimId = vehicleCopy?.trimName;
  }
  return transformedVehicle;
};
export const getVehicleCommonDataLayer = function (inventory, includeWalletData) {
  if (inventory === void 0) {
    inventory = {};
  }
  if (includeWalletData === void 0) {
    includeWalletData = false;
  }
  const inventoryCopy = cloneDeep(inventory);
  const {
    id,
    bodyStyleCodes,
    style,
    description,
    additionalInfo,
    driveGroup,
    driveType,
    fuelType,
    owner,
    classSeriesCode,
    series,
    subCategory,
    transmissionGroup,
    transmission,
    atTrim,
    trimCode,
    trim
  } = inventoryCopy;
  const bodyStyleCode = Array.isArray(bodyStyleCodes) ? bodyStyleCodes[0] : bodyStyleCodes;
  const inventoryStyle = Array.isArray(style) ? style[0] : style;
  return {
    bodyStyleGroup: bodyStyleCode?.toLowerCase() || inventoryStyle?.toLowerCase(),
    descriptionExists: description?.label || additionalInfo?.vehicleDescription ? 'yes' : 'no',
    driveTrain: driveGroup || driveType?.name?.toLowerCase(),
    fuelType: fuelType?.name?.toLowerCase() || fuelType || {},
    legacyConfigurationId: id,
    productConfiguration: getProductConfiguration(inventoryCopy, includeWalletData),
    sellerType: owner.privateSeller ? 'private-seller' : 'dealer',
    seriesId: classSeriesCode?.toLowerCase() || series,
    subCategory,
    transmission: transmissionGroup || transmission?.name?.toLowerCase() || transmission || {},
    trimId: atTrim?.toLowerCase() || trimCode?.toLowerCase() || trim?.code?.toLowerCase()
  };
};
export default {
  getInventoryData,
  buildListingChunks,
  getCDLVehicleTransformer,
  getVehicleCommonDataLayer
};